import { Icon, IconProps } from "./Icon";

export function IconMug(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M18.89 16.85A3.95 3.95 0 0 0 19 9.16V6h-5a6.54 6.54 0 0 1 .69-2.17A6.79 6.79 0 0 0 15.51 1h-1a5.92 5.92 0 0 1-.71 2.41A7 7 0 0 0 13 6H7a6.61 6.61 0 0 1 .7-2.17A6.74 6.74 0 0 0 8.5 1h-1a6 6 0 0 1-.71 2.42A7.06 7.06 0 0 0 6 6H2v9.51A8.49 8.49 0 0 0 6.51 23H4v1h13v-1h-2.5a8.5 8.5 0 0 0 4.39-6.15ZM21 13a3 3 0 0 1-2 2.79 2.28 2.28 0 0 0 0-.27v-5.33A3 3 0 0 1 21 13ZM10.5 23A7.51 7.51 0 0 1 3 15.51V7h15v8.51A7.51 7.51 0 0 1 10.5 23Zm1.21-20.24A6 6 0 0 0 12.52 0h-1a5.19 5.19 0 0 1-.7 2.31A5.79 5.79 0 0 0 10 5h1a4.91 4.91 0 0 1 .71-2.24Z" />
    </Icon>
  );
}
